import { render, staticRenderFns } from "./matchplay.vue?vue&type=template&id=5c3011ae&scoped=true"
import script from "./matchplay.vue?vue&type=script&lang=js"
export * from "./matchplay.vue?vue&type=script&lang=js"
import style0 from "./matchplay.vue?vue&type=style&index=0&id=5c3011ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3011ae",
  null
  
)

export default component.exports